// React imports.
import React from "react";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";


const Assessment1TopParagraph = ({fuelType, state }) => (
    <div>
      {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues)
          &&  <p>
                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your computed average  electric baseload expenditures for {fuelType.description} households is
                &nbsp;{fuelType.percentOfSedsString}&nbsp;of the
                estimated average for your state based on the ACS. Since the value reflected in
                your data is between 50% and 150% of the ACS estimate, it is unlikely that you
                have a major data reliability issue with regards to electric baseload expenditures
                for {fuelType.description} households.
            </p>
        }
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
            && fuelType.totalAssistedhHNum===0)
        &&
            <p>
                <strong>
                    Status: N/A -
                </strong>&nbsp;
                You indicated that you DO NOT serve households that
                heat with &nbsp;{fuelType.description}. Therefore,
                there is no data here to check. Please click next.
            </p>
        }
    
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
            && fuelType.totalAssistedhHNum>0)
        &&
            <React.Fragment>
                <p>
                    <strong>
                        Status: Potential data reliability issue present.
                    </strong>&nbsp;
                    Your computed average electric baseload expenditures
                    for&nbsp;{fuelType.description}&nbsp;households have been flagged because
                    your Performance Measures Form indicates that you assisted
                    households that used &nbsp;{fuelType.description}&nbsp; for heating
                    in &nbsp;{state.SelectedYear}&nbsp; but you DID NOT collect or report
                    any electric baseload billing data for those households.
                </p>
                <p>
                    This means that you are either not collecting electric baseload
                    data for &nbsp;{fuelType.description}&nbsp; households or you are not
                    collecting electric baseload data that is complete
                    enough to be reported.
                </p>
            </React.Fragment>
        }

        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin)
            &&
            <React.Fragment>
                <p>
                    <strong>
                      Status: Potential data reliability issue present!
                    </strong>&nbsp;
                    Your computed average electric baseload expenditures
                    for &nbsp;{fuelType.descriptionHeat}&nbsp; households have been flagged because your
                    data is &nbsp;{fuelType.percentOfSedsString}&nbsp; of the estimated average electric bill
                    for &nbsp;{fuelType.descriptionHeat}&nbsp; households in your state using the ACS.
                </p>
                <p>
                    This means that your computed average electric baseload
                    expenditures for &nbsp;{fuelType.descriptionHeat}&nbsp; households is showing that
                    your low-income households are spending  &nbsp;{fuelType.percentSpendingLessString}&nbsp; less on
                    baseload electricity than we would expect. 
                </p>
            </React.Fragment>
        }
        
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax)
            &&
            <React.Fragment>
                <p>
                    <strong>
                        Status: Potential data reliability issue present!
                    </strong>&nbsp;
                    Your computed average electric baseload expenditures
                    for &nbsp;{fuelType.descriptionHeat}&nbsp; households
                    have been flagged because your data
                    is &nbsp;{fuelType.percentOfSedsString}&nbsp; of the estimated
                    average for &nbsp;{fuelType.descriptionHeat}&nbsp; households
                    in your state using the ACS.
                </p>
                <p>
                    This means that your computed average electric baseload expenditures
                    for &nbsp;{fuelType.descriptionHeat}&nbsp; households is showing that
                    your low-income households are
                    spending &nbsp;{fuelType.percentSpendingMoreString}&nbsp; more on
                    baseload load electricity than we would expect. 
                </p>
            </React.Fragment>
        }
        {fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
        &&
            <p>
                <strong>
                    Status: N/A.
                </strong>&nbsp;

                Your computed average expenditures for&nbsp;{fuelType.descriptionHeat}&nbsp;households have
                not been flagged because there is no
                modified ACS data available for households that heat with&nbsp;{fuelType.description}&nbsp;in
                your state. This means that very few households in your
                state heat with &nbsp;{fuelType.descriptionHeat}.
            </p>
        }
    
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
            && fuelType.totalAssistedhHNum===null)
        &&
            <p>
                <strong>
                    Status: N/A.
                </strong>&nbsp;
                Your state did not file a complete  Performance Measures report for 
                households that used&nbsp;{fuelType.description}&nbsp;for heating in
                &nbsp;{state.SelectedYear}, so we are not able to check the validity of your data.
            </p>
        }
    </div>
);

export default Assessment1TopParagraph;
